// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var Theme = require("../styles/Theme.js");
var TypedGlamor = require("bs-typed-glamor/src/TypedGlamor.bs.js");

var root = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.display(TypedGlamor.flex),
      /* :: */[
        TypedGlamor.justifyContent(TypedGlamor.spaceBetween),
        /* :: */[
          TypedGlamor.marginBottom(TypedGlamor.em(0.5)),
          /* [] */0
        ]
      ]
    ]);

var name = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.textDecoration(TypedGlamor.none),
      /* :: */[
        TypedGlamor.hover(/* :: */[
              TypedGlamor.textDecoration(TypedGlamor.underline),
              /* [] */0
            ]),
        /* [] */0
      ]
    ]);

var version = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.fontSize(TypedGlamor.em(0.85)),
      /* :: */[
        TypedGlamor.fontStyle(TypedGlamor.italic),
        /* :: */[
          TypedGlamor.marginLeft(TypedGlamor.em(0.5)),
          /* :: */[
            TypedGlamor.opacity(0.5),
            /* [] */0
          ]
        ]
      ]
    ]);

var updated = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.opacity(0.5),
      /* :: */[
        TypedGlamor.fontSize(TypedGlamor.em(0.85)),
        /* :: */[
          TypedGlamor.whiteSpace(TypedGlamor.nowrap),
          /* :: */[
            TypedGlamor.opacity(0.75),
            /* [] */0
          ]
        ]
      ]
    ]);

var stars = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.opacity(0.5),
      /* :: */[
        TypedGlamor.fontSize(TypedGlamor.em(0.85)),
        /* :: */[
          TypedGlamor.whiteSpace(TypedGlamor.nowrap),
          /* :: */[
            TypedGlamor.opacity(0.75),
            /* [] */0
          ]
        ]
      ]
    ]);

var starIcon = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.marginLeft(TypedGlamor.em(0.25)),
      /* :: */[
        TypedGlamor.transforms(/* :: */[
              TypedGlamor.translateY(TypedGlamor.px(-1)),
              /* [] */0
            ]),
        /* :: */[
          TypedGlamor.unsafe("fill", Theme.Inverted[/* Color */0][/* text */1]),
          /* :: */[
            TypedGlamor.opacity(0.5),
            /* [] */0
          ]
        ]
      ]
    ]);

exports.root = root;
exports.name = name;
exports.version = version;
exports.updated = updated;
exports.stars = stars;
exports.starIcon = starIcon;
/* root Not a pure module */



// WEBPACK FOOTER //
// ./src/components/TopListStyles.js